export default __webpack_public_path__ + "static/media/about_banner.fdc13290.png";